import React, { useEffect, useState } from 'react'
import "./Calculator.scss";
import NumberFormat from 'react-number-format';
import { InputAdornment } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';

function NumberFormatCustom(props) {
    const { inputRef, onChange, ...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            inputMode="decimal"
            decimalScale={2}
            onValueChange={values => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value ? values.value : 0.00
                    }
                });
            }}
            thousandSeparator
            isNumericString
        />
    );
}


const CompareTCO = (props) => {

    const selectItemstartbucket = (item) => {
        props.start_bucket_change(item)
        props.handleDisplayModalstartbucket(!props.displayModalstartbucket)
    }

    const selectItemendbucket = (item) => {
        props.end_bucket_change(item)
        props.handleDisplayModalendbucket(!props.displayModalendbucket)
    }

    const removeDegitSaraly = (number) => {
        if (number) {
            var parts = number.toString().split(".");
            parts[0] = parts[0].replace(",", "");
            let numbera = parts.join(".");
            return numbera;
        } else {
            return " ";
        }
    };

    const chstartprice = (e) => {
        // let num = removeDegitSaraly(e)
        // console.log(num)
        // console.log(formatMoney(num))

        props.setstartprice(e)
    }

    const chendprice = (e) => {
        // let num = removeDegitSaraly(e)
        // console.log(num)
        // console.log(formatMoney(num))
        props.setendprice(e)
    }

    return (
        <>
            <div className="container " style={{ backgroundColor: "#fff" }}>

                <div className="row" style={{ paddingTop: "15px", backgroundColor: "#ECECEC" }}>
                    <div className="col-6">
                        <p
                            style={{
                                fontSize: "14px",
                                color: "#000",
                                textAlign: "center"
                            }}
                        >
                            {props.startcomparison_model ? props.startcomparison_model : "Please select model ..."}
                        </p>
                    </div>
                    <div className="col-6">
                        <p
                            style={{
                                fontSize: "14px",
                                color: "#000",
                                textAlign: "center"
                            }}
                        >
                            {props.endcomparison_model ? props.endcomparison_model : ""}
                        </p>
                    </div>
                </div>

                <div
                    style={{
                        paddingBottom: "5px",
                        paddingTop: "5px",
                        backgroundColor: "#F9F9F9"
                    }}
                >
                    <span
                        style={{
                            fontSize: "14px",
                            color: "#999999",
                            paddingBottom: "5px",
                            paddingTop: "5px",
                        }}
                    >
                        Price
                    </span>
                </div>

                <div className="row" style={{
                    paddingBottom: "10px",
                    paddingTop: "10px",
                }}>
                    <div className="col-6 d-flex justify-content-between">
                        {/* <input
                            className="input-price"
                            type="number"
                            min="0"
                            inputmode="numeric"
                            pattern="[0-9]*\."
                            placeholder="Price"
                            value={props.startprice}
                            onChange={(e) => chstartprice(e.target.value)}
                        /> */}
                        <TextField
                            value={props.startprice ? Number(props.startprice).toFixed(2) : ""}
                            onChange={(e) => chstartprice(parseFloat(e.target.value))}
                            // label="Price"
                            // variant="outlined"
                            style={{ width: "100%" }}
                            name="numberformat"
                            id="formatted-numberformat-input"
                            InputProps={{
                                inputComponent: NumberFormatCustom,
                                endAdornment: (
                                    <InputAdornment position="end">{props.currency}</InputAdornment>
                                )
                            }}
                        />

                        {/* <NumberFormat
                            className="input-price"
                            thousandSeparator={true}
                            type="tel" decimalScale={2}
                            value={props.startprice}
                            onChange={(e) => chstartprice(e.target.value)}
                        />

                        <span style={{ color: "#737373", textAlign: "right" }}>
                            {props.currency}
                        </span> */}
                    </div>
                    <div className="col-6 d-flex justify-content-between">

                        <TextField
                            value={props.endprice ? Number(props.endprice).toFixed(2) : ""}
                            onChange={(e) => chendprice(parseFloat(e.target.value))}
                            // label="Price"
                            // variant="outlined"
                            style={{ width: "100%" }}
                            name="numberformat"
                            id="formatted-numberformat-input"
                            InputProps={{
                                inputComponent: NumberFormatCustom,
                                endAdornment: (
                                    <InputAdornment position="end">{props.currency}</InputAdornment>
                                )
                            }}
                        />

                        {/* <NumberFormat
                            className="input-price"
                            thousandSeparator={true}
                            type="tel" decimalScale={2}
                            value={props.endprice}
                            onChange={(e) => chendprice(e.target.value)}
                        /> */}

                        {/* <input
                            className="input-price"
                            type="number"
                            min="0"
                            inputmode="numeric"
                            pattern="[0-9]*\."
                            placeholder="Price"
                            value={props.endprice}
                            onChange={(e) => chendprice(e.target.value)}
                        /> */}
                        {/* <span style={{
                            color: "#737373"
                            , textAlign: "right"
                        }}>
                            {props.currency}
                        </span> */}
                    </div>
                </div>

                <div
                    style={{
                        paddingBottom: "5px",
                        paddingTop: "5px",
                        backgroundColor: "#F9F9F9"
                    }}
                >
                    <span
                        style={{
                            fontSize: "14px",
                            color: "#999999",
                            paddingBottom: "5px",
                            paddingTop: "5px",
                        }}
                    >
                        Bucket
                    </span>
                </div>

                <div className="row" style={{
                    paddingBottom: "10px",
                    paddingTop: "10px",
                }}
                >
                    <div className="col-6 d-flex justify-content-between"
                        onClick={() => props.handleDisplayModalstartbucket(!props.displayModalstartbucket)}
                    >
                        <span
                            style={{
                                fontSize: "14px",
                                color: "#000",
                            }}
                        >
                            {props.startbucket} {props.startbucket === "Select Bucket" ? "" : <>m<sup>3</sup></>}
                        </span>
                        <span style={{ color: "#737373", textAlign: "right" }}>
                            <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.184424 11.8192C-0.0391203 11.6001 -0.0594426 11.2571 0.123458 11.0155L0.184424 10.9462L5.23006 6L0.184424 1.05377C-0.0391203 0.83462 -0.0594426 0.491687 0.123458 0.250032L0.184424 0.180798C0.407969 -0.0383512 0.75778 -0.0582738 1.00428 0.12103L1.0749 0.180798L6.56558 5.56351C6.78912 5.78266 6.80944 6.1256 6.62654 6.36725L6.56558 6.43649L1.0749 11.8192C0.829005 12.0603 0.430324 12.0603 0.184424 11.8192Z" fill="#200E32" />
                            </svg>

                        </span>
                    </div>
                    <div className="col-6 d-flex justify-content-between"
                        onClick={() => props.handleDisplayModalendbucket(!props.displayModalendbucket)}
                    >
                        <span
                            style={{
                                fontSize: "14px",
                                color: "#000",
                            }}
                        >
                            {props.endbucket} {props.endbucket === "Select Bucket" ? "" : <>m<sup>3</sup></>}
                        </span>
                        <span style={{
                            color: "#737373",
                            textAlign: "right"
                        }}>
                            <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.184424 11.8192C-0.0391203 11.6001 -0.0594426 11.2571 0.123458 11.0155L0.184424 10.9462L5.23006 6L0.184424 1.05377C-0.0391203 0.83462 -0.0594426 0.491687 0.123458 0.250032L0.184424 0.180798C0.407969 -0.0383512 0.75778 -0.0582738 1.00428 0.12103L1.0749 0.180798L6.56558 5.56351C6.78912 5.78266 6.80944 6.1256 6.62654 6.36725L6.56558 6.43649L1.0749 11.8192C0.829005 12.0603 0.430324 12.0603 0.184424 11.8192Z" fill="#200E32" />
                            </svg>

                        </span>
                    </div>
                </div>


                <div className={`Modal ${props.displayModalstartbucket ? "Show" : ""}`}>
                    <div style={{ marginTop: "10px" }}>
                        <h3>Bucket</h3>
                    </div>

                    <button
                        className="Close"
                        onClick={() => props.handleDisplayModalstartbucket(!props.displayModalstartbucket)}
                    >
                        X
                </button>
                    <hr />

                    {props.datastartbucket.length > 0 ? props.datastartbucket.map((item, key) => {
                        return (
                            <div key={key} className="container" onClick={() => selectItemstartbucket(item)}>
                                <p>{item.bucket}</p>
                                <hr />

                            </div>
                        )
                    }) : "No data"}
                </div>

                <div
                    className={`Overlay ${props.displayModalstartbucket ? "Show" : ""}`}
                    onClick={() => props.handleDisplayModalstartbucket(!props.displayModalstartbucket)}
                />


                <div className={`Modal ${props.displayModalendbucket ? "Show" : ""}`}>
                    <div style={{ marginTop: "10px" }}>
                        <h3>Bucket</h3>
                    </div>

                    <button
                        className="Close"
                        onClick={() => props.handleDisplayModalendbucket(!props.displayModalendbucket)}
                    >
                        X
                </button>
                    <hr />

                    {props.dataendbucket.length > 0 ? props.dataendbucket.map((item, key) => {
                        return (
                            <div key={key} className="container" onClick={() => selectItemendbucket(item)}>
                                <p>{item.bucket}</p>
                                <hr />

                            </div>
                        )
                    }) : "No data"}
                </div>

                <div
                    className={`Overlay ${props.displayModalendbucket ? "Show" : ""}`}
                    onClick={() => props.handleDisplayModalendbucket(!props.displayModalendbucket)}
                />

            </div>
        </>
    )
}

export default CompareTCO
